import config from 'config'

const authApi = `${config.apiHost}/oem-auth`

export default {
    sub: {
        url: `${authApi}/api/users/sub`,
        type: 'GET',
    },
    summary: {
        url: `${authApi}/api/users/summary`,
        type: 'GET',
    },
    usersSearch: {
        url: `${authApi}/api/users/search`,
        type: 'GET',
    },
    usersIndependent: {
        url: `${authApi}/api/users/sub/independent`,
        type: 'GET',
    },
    customersSuggest: {
        url: `${config.apiHost}/oem-customer/api/customers/suggest`,
        type: 'POST',
    },
    getGroupList: {
        url: `${authApi}/api/users/poly/list`,
        type: 'GET',
    },
    saveGroup: {
        url: `${authApi}/api/users/poly/add`,
        type: 'POST',
    },

    editGroup: {
        url: `${authApi}/api/users/poly/{id}`,
        type: 'PUT',
    },
    delGroup: {
        url: `${authApi}/api/users/poly/delete/{id}`,
        type: 'DELETE',
    },
}
